export class PetTagListModel { 
    tag_no: string
    pet_no: number
    pet_name: string
    location:string
    sublocation:number
    department:string 
    done_by:string 

    constructor( 
        tag_no: string,
        pet_no: number,
        pet_name: string,
        location:string,
        sublocation:number,
        department:string,
        done_by:string

    ) {  
        this.tag_no = tag_no
        this.pet_no = pet_no 
        this.pet_name = pet_name 
        this.location = location 
        this.sublocation = sublocation 
        this.department = department
        this.done_by = done_by  
    }


}

export class InvPetListModel {
    tag_no: string
    pet_no: number
    pet_name: string 

    constructor(
        tag_no: string,
        pet_no: number,
        pet_name: string, 

    ) { 
        this.tag_no = tag_no
        this.pet_no = pet_no 
        this.pet_name = pet_name  
    }


}